export const GET_STATION_CONFIG = gql`
  query GetStationConfig($id: String!) {
    station(id: $id) {
      borderStation
      id
      isLocalPublicDemoMember
      isLocalPublicMember
      name
    }
  }
`

export const UPDATE_STATION_CONFIG = gql`
  mutation UpdateStationConfig($id: String!, $input: UpdateStationInput!) {
    updateStation(id: $id, input: $input) {
      borderStation
      id
      isLocalPublicDemoMember
      isLocalPublicMember
      name
    }
  }
`
